import React from 'react';
import { QRCodeCanvas } from 'qrcode.react';

export default function QRModal({ link, onClose }) {
    if (!link) return null;

    // Ensure valid URL
    const qrValue = link.fullUrl && (link.fullUrl.startsWith('http') || link.fullUrl.startsWith('https'))
        ? link.fullUrl
        : `${window.location.origin}${link.fullUrl?.startsWith('/') ? '' : '/'}${link.fullUrl}`;

    const downloadQR = () => {
        const canvas = document.getElementById('qr-canvas');
        if (canvas) {
            const pngUrl = canvas.toDataURL('image/png');
            const downloadLink = document.createElement('a');
            downloadLink.href = pngUrl;
            const name = `QR-${link.agent?.numeComplet || 'Agent'}-${link.landingPage?.titlu || 'LP'}.png`;
            downloadLink.download = name.replace(/\s+/g, '-');
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
        }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white dark:bg-slate-800 rounded-xl p-6 max-w-sm w-full shadow-2xl relative animate-fade-in-up border border-gray-200 dark:border-slate-700">
                <button
                    onClick={onClose}
                    className="absolute top-4 right-4 text-gray-400 dark:text-gray-500 hover:text-gray-600 dark:hover:text-gray-300 transition-colors"
                >
                    ✕
                </button>

                <div className="text-center">
                    <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-2">Cod QR Link</h3>
                    <p className="text-sm text-gray-500 dark:text-gray-400 mb-6 break-words px-2">{link.landingPage?.titlu}</p>

                    <div className="bg-white dark:bg-slate-700 p-4 rounded-xl shadow-inner border border-gray-100 dark:border-slate-600 inline-block mb-6">
                        <QRCodeCanvas
                            id="qr-canvas"
                            value={qrValue}
                            size={250}
                            level={"H"}
                            includeMargin={true}
                            imageSettings={{
                                src: "/logo192.png",
                                x: undefined,
                                y: undefined,
                                height: 24,
                                width: 24,
                                excavate: true,
                            }}
                        />
                    </div>

                    <p className="text-xs text-gray-400 dark:text-gray-500 mb-4 break-all font-mono bg-gray-50 dark:bg-slate-700 p-2 rounded">
                        {qrValue}
                    </p>

                    <div className="flex gap-3">
                        <button
                            onClick={downloadQR}
                            className="flex-1 bg-brand-blue text-white px-4 py-2.5 rounded-lg hover:bg-brand-blue-hover font-medium shadow-md transition-all active:scale-95 flex items-center justify-center gap-2"
                        >
                            <span>⬇️</span> Descarcă PNG
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
